export type IdeaAdFormat = 'image' | 'video'

export function normalizeIdeaAdFormat(adFormat?: string | null): IdeaAdFormat {
  if (!adFormat) return 'image'

  const normalized = adFormat.trim().toLowerCase()
  if (normalized === 'video' || normalized === 'short_video_15s' || normalized === 'short_video_30s' || normalized === 'ugc_style') {
    return 'video'
  }
  if (normalized === 'image' || normalized === 'static_image' || normalized === 'carousel') {
    return 'image'
  }
  return 'image'
}

export function prioritizeIdeasByFormat<T extends { ad_format?: string | null }>(
  ideas: T[],
  preferredFormat: IdeaAdFormat
): T[] {
  return ideas
    .map((idea, idx) => ({
      idea,
      idx,
      priority: normalizeIdeaAdFormat(idea.ad_format) === preferredFormat ? 0 : 1,
    }))
    .sort((a, b) => a.priority - b.priority || a.idx - b.idx)
    .map((x) => x.idea)
}
